function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { forwardRef } from 'react';
import { Container, Reviews } from './elements';
import { Star } from './Star';
import { Tooltip } from '../Tooltip';
import { Text } from '../Text';
import { attachSubComponents } from '../../util';
export const StarRating = attachSubComponents('StarRating', /*#__PURE__*/forwardRef(({
  value = 0,
  tooltip = '',
  label = '',
  color = 'default',
  variant = 'static',
  children,
  ...props
}, fRef) => {
  const starLabel = !!label && /*#__PURE__*/React.createElement(Text, {
    key: "label",
    size: 1,
    weight: "heavy",
    color: "var(--aui-on-surface)",
    lineHeight: variant === 'numberOnly' ? '1rem' : '1'
  }, label);
  let content;
  if (variant == 'numberOnly') {
    content = [starLabel, /*#__PURE__*/React.createElement(Star, {
      key: 0,
      color: color,
      percentage: 1.0
    }), children];
  } else {
    content = [...Array.from({
      length: 5
    }, (_, i) => /*#__PURE__*/React.createElement(Star, {
      key: i,
      color: color,
      percentage: Math.max(0, Math.min(1.0, value - i))
    })), starLabel, children];
  }
  const title = variant == 'static' ? `a ${value} star rating` : 'a star icon';
  return /*#__PURE__*/React.createElement(Tooltip, {
    label: tooltip
  }, /*#__PURE__*/React.createElement(Container, _extends({
    "data-aui": "star-rating",
    ref: fRef,
    title: title
  }, props), content));
}), {
  Reviews
});